import { EmaIntersectsFirstCandleLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setupFilters/EmaIntersectsFirstCandleLine';
import { EmaIntersectsFirstCandleTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/setupFilters/EmaIntersectsFirstCandleTacticPanel';
import { EmaIntersectsFirstCandleWrapper } from '../../../../components/displays/tradeplans/softOrderModules/SetupFilterModules/EmaIntersectsFirstCandleModule/wrapper/EmaIntersectsFirstCandleWrapper';
import EmaIntersectsFirstCandleDocs from '../../../../components/forms/tradeplans/documentation/EmaFirstCandleDocumentation';
import { EmaIntersectsFirstCandleData } from './emaIntersectsFirstCandleData';
import { validateEmaIntersectsFirstCandle } from './validateEmaIntersectsFirstCandle';



export const EmaIntersectsFirstCandle = {
  //data class
  dataStore: EmaIntersectsFirstCandleData,

  //string constants
  name: 'EMA_INTERSECTS_FIRST_CANDLE',
  tacticLabel: 'EMA Intersects First Candle',
  addTacticLabel: 'Add EMA Intersects First Candle',
  category: 'Setup Filter',

  // components
  tradePlanFormModule: null,
  tacticPanel: EmaIntersectsFirstCandleTacticPanel,
  addTacticPanel: null,
  wrapper: EmaIntersectsFirstCandleWrapper,
  chartSoftOrderComponent: EmaIntersectsFirstCandleLine,
  documentation: EmaIntersectsFirstCandleDocs,
  alertDetailsComponent: null,

  //functions
  setupDetailParser: null, 
  filterStatusParser: null, //todo
  validationFunction: validateEmaIntersectsFirstCandle,
};
